import MobxSelect from './MobxSelect'

export default MobxSelect
